import { usePublicApp } from "@/shared/hooks/useApps";
import { useAuth } from "@/shared/hooks/useAuth";
import { useNavigate } from "react-router-dom";

export const useGameInfo = (gameSlug: string) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const { data: game, isLoading, error } = usePublicApp(gameSlug);

  const handlePlayGame = () => {
    if (game?.slug) {
      if (isAuthenticated) {
        // Если пользователь авторизован, переходим сразу на игру
        navigate(`/game/${game.slug}`);
      } else {
        // Если не авторизован, переходим на страницу авторизации
        // Сохраняем целевую страницу в state для редиректа после логина
        navigate("/login", {
          state: { from: { pathname: `/game/${game.slug}` } },
        });
      }
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToGamesList = () => {
    navigate("/games");
  };

  return {
    game,
    isLoading,
    error,
    handlePlayGame,
    handleGoBack,
    handleGoToGamesList,
  };
};
